<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>Confirmação de Email</h1>
                <spinner v-if="loading == true"></spinner> 
                <b-alert
                    v-if="errorMessage"
                    show
                    variant="danger"
                  >{{errorMessage}}</b-alert>
                <b-alert
                  v-if="success"
                  show
                  variant="success"
                >Email confirmado, você já pode acessar o Sleeker e usar os posts gratuitos.</b-alert>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import service from "../../service";
import Spinner from "../Spinner";

export default {
  name: 'EmailConfirmation',
  data: function() {
    return {
      loading: true,
      errorMessage: undefined,
      success: false
    }
  },
  created() {
    service.confirmEmail(this.$route.params.token).then((result) => {
      this.loading = false;
      this.success = true;
      setTimeout(() => {
        //this.$router.push("/pages/login");
      }, 3000);
    }).catch(error => {
      this.loading = false;
      if (error && error.message) {
        this.errorMessage = error.message;
      } else {
        this.errorMessage = "Ocorreu um erro inesperado, procure o suporte se ele se repetir.";
      }
    });
  },
  components: {Spinner}
}
</script>
